var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "职责权限", name: "roleTpl" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "岗位", name: "role" } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.activeName == "roleTpl"
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.merchtTplRoleList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      prop: "confName",
                      label: "职责权限名称"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      prop: "realName",
                      label: "目标岗位名称"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mobAppRoleName",
                      label: "移动端角色",
                      width: "80"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "140",
                      prop: "shopFlag",
                      align: "center",
                      label: "是否门店专用"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(rows.row.shopFlag ? "是" : "否"))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      prop: "comLevel",
                      label: "适用级别",
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return !rows.row.shopFlag
                            ? [
                                rows.row.comLevel1
                                  ? _c("span", [_vm._v("一级业务单元")])
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.comLevel2
                                  ? _c("span", [
                                      rows.row.comLevel1
                                        ? _c("span", [_vm._v("，")])
                                        : _vm._e(),
                                      _vm._v("二级业务单元")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.comLevel3
                                  ? _c("span", [
                                      rows.row.comLevel1 || rows.row.comLevel2
                                        ? _c("span", [_vm._v("，")])
                                        : _vm._e(),
                                      _vm._v("三级业务单元")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                rows.row.comLevel4
                                  ? _c("span", [
                                      rows.row.comLevel1 ||
                                      rows.row.comLevel2 ||
                                      rows.row.comLevel3
                                        ? _c("span", [_vm._v("，")])
                                        : _vm._e(),
                                      _vm._v("四级业务单元")
                                    ])
                                  : _vm._e()
                              ]
                            : undefined
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "140",
                      prop: "bizPermFlag",
                      align: "center",
                      label: "业务权限限制"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(rows.row.bizPermFlag ? "启用" : "关闭")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      prop: "bizPermOrgFlag",
                      label: "业务权限模式"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.bizPermOrgFlagEnumMap[
                                    rows.row.bizPermOrgFlag
                                  ]
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "120",
                      prop: "bizPermScopName",
                      label: "业务范围"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "desc",
                      label: "描述",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "操作",
                      align: "left",
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.syncSubscrMsgForRolTpl(
                                      rows.row.id,
                                      true
                                    )
                                  }
                                }
                              },
                              [_vm._v("覆盖订阅")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.syncSubscrMsgForRolTpl(
                                      rows.row.id,
                                      false
                                    )
                                  }
                                }
                              },
                              [_vm._v("追加订阅")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-layout" },
                [
                  _vm.totalCount > 0
                    ? _c("el-pagination", {
                        attrs: {
                          background: "",
                          "page-size": _vm.pageSize,
                          "page-sizes": _vm.pageSizes,
                          "current-page": _vm.pageNumber,
                          total: _vm.totalCount,
                          layout: "prev, pager, next, jumper, sizes, total"
                        },
                        on: {
                          "current-change": _vm.handlePageChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c("div", { staticClass: "column-layout clearfix" }, [
            _c(
              "div",
              {
                staticClass: "left-column fl",
                class: { active: !_vm.treeCollapse }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "overflow-y": "auto" },
                    attrs: { id: "tree-menu" }
                  },
                  [
                    _c("swb-org-tree", {
                      attrs: { searchSize: "mini", enableSearch: true },
                      on: {
                        "notity-change": function($event) {
                          _vm.notityChange($event)
                        },
                        "show-tree-collapse": function($event) {
                          _vm.showTreeCollapse($event)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right-column fl" }, [
              _c(
                "div",
                { staticClass: "mt10 mb10" },
                [
                  _c("label", [_vm._v("岗位：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      on: { change: _vm.thisRoleIdChange },
                      model: {
                        value: _vm.thisRoleId,
                        callback: function($$v) {
                          _vm.thisRoleId = $$v
                        },
                        expression: "thisRoleId"
                      }
                    },
                    _vm._l(_vm.roleList, function(item) {
                      return _c("el-option", {
                        attrs: { label: item.name, value: item.id }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "swb-btn swb-btn-mini fr",
                      on: {
                        click: function($event) {
                          _vm.syncSubscrMsgForStaff(true)
                        }
                      }
                    },
                    [_vm._v("覆盖订阅")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "swb-btn swb-btn-mini fr mr5",
                      on: {
                        click: function($event) {
                          _vm.syncSubscrMsgForStaff(false)
                        }
                      }
                    },
                    [_vm._v("追加订阅")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-layout" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.staffList, border: "" },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "40",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          width: "130",
                          prop: "name",
                          label: "员工姓名"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "130",
                          prop: "contactTel",
                          label: "联系电话"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "180",
                          prop: "contactEmail",
                          label: "联系邮箱"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "80",
                          prop: "osFlag",
                          label: "是否外协"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.osFlag
                                  ? _c("span", { staticClass: "font-green" }, [
                                      _vm._v("是")
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "80",
                          prop: "csFlag",
                          label: "是否客服"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.csFlag
                                  ? _c("span", { staticClass: "font-green" }, [
                                      _vm._v("是")
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "100",
                          prop: "enrollDate",
                          label: "入职日期"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "100",
                          prop: "quitDate",
                          label: "离职日期"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "80",
                          prop: "disabled",
                          label: "是否禁用"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                rows.row.disabled
                                  ? _c("span", { staticClass: "font-red" }, [
                                      _vm._v("是")
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "disabledCause",
                          label: "禁用描述",
                          "show-overflow-tooltip": ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("组织机构")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09ff44ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09ff44ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizMsg/BizEventMsgSubscrTplSetStaff.vue
// module id = 3953
// module chunks = 0